import { render, staticRenderFns } from "./ResponseChoiceList.vue?vue&type=template&id=1deea134&"
import script from "./ResponseChoiceList.vue?vue&type=script&lang=js&"
export * from "./ResponseChoiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports